import { useState, useEffect } from 'react';

/**
 * 프로젝트 관리를 담당하는 커스텀 훅
 * @param {Array} history - 히스토리 배열
 * @param {number} selectedHistoryId - 선택된 히스토리 ID
 * @param {function} setSelectedHistoryId - 선택된 히스토리 ID 설정 함수
 * @returns {object} - 프로젝트 관리 관련 상태와 함수들
 */
export const useProjectManagement = (history, selectedHistoryId, setSelectedHistoryId) => {
  const [openProjects, setOpenProjects] = useState({});
  const [menuOpenIdx, setMenuOpenIdx] = useState(null);
  const [isAnyHistoryEditing, setIsAnyHistoryEditing] = useState(false);

  /**
   * 프로젝트 폴더 열기/닫기 토글
   * @param {string} projectId - 프로젝트 ID
   */
  const toggleProject = (projectId) => {
    setOpenProjects(prev => ({
      ...prev,
      [projectId]: !prev[projectId]
    }));
  };

  // 최근 히스토리에서 선택된 아이템이 사라지면 인덱스 리셋
  useEffect(() => {
    const recentHistory = history.filter(h => !h.projectId);
    if (selectedHistoryId >= recentHistory.length) {
      setSelectedHistoryId(0);
    }
  }, [history, selectedHistoryId, setSelectedHistoryId]);

  return {
    openProjects,
    setOpenProjects,
    menuOpenIdx,
    setMenuOpenIdx,
    isAnyHistoryEditing,
    setIsAnyHistoryEditing,
    toggleProject
  };
}; 